
export const BraspagScheduleParser = {
  getBraspagSchedule ({ data, meta }) {
    return {
      data: data || [],
      meta: Object.keys(meta || {}).length > 0
        ? meta
        : {
          currentPage: 0,
          pageSize: 0,
          totalEntries: 0,
          totalItemSchedules: 0,
          totalPages: 0
        }
    }
  }
}
